import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Button, Layout, Menu } from "antd";
import { ExportOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import Logo from './Logo';
import NavPanel from './NavPanel';
import NavProfile from './NavProfile';
import NavSearch  from './NavSearch';
import { toggleCollapsedNav, onMobileNavToggle } from 'redux/actions/Theme';
import { NAV_TYPE_TOP, SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_WIDTH } from 'constants/ThemeConstant';
import { ENV_CONFIG } from "utils/envConfig";
import utils from 'utils'

const { Header } = Layout;
const PRODUCTION_HOSTNAME = 'payments.mykowri.com';

export const HeaderNav = props => {
  const { navCollapsed, mobileNav, navType, headerNavColor, toggleCollapsedNav, onMobileNavToggle, isMobile, currentTheme } = props;
  const [searchActive, setSearchActive] = useState(false)

  const onSearchClose = () => {
    setSearchActive(false)
  }

  const onToggle = () => {
    if(!isMobile) {
      toggleCollapsedNav(!navCollapsed)
    } else {
      onMobileNavToggle(!mobileNav)
    }
  }

  const isNavTop = navType === NAV_TYPE_TOP ? true : false
  const mode = ()=> {
    if(!headerNavColor) {
      return utils.getColorContrast(currentTheme === 'dark' ? '#00000' : '#ffffff' )
    }
    return utils.getColorContrast(headerNavColor)
  }
  const navMode = mode()
  const getNavWidth = () => {
    if(isNavTop || isMobile) {
      return '0px'
    }
    if(navCollapsed) {
      return `${SIDE_NAV_COLLAPSED_WIDTH}px`
    } else {
      return `${SIDE_NAV_WIDTH}px`
    }
  }
  const showNewAppCta = ENV_CONFIG.REACT_APP_SHOW_NEW_APP_CTA === 'true'
  const newAppUrl = window.location.hostname === PRODUCTION_HOSTNAME
    ? ENV_CONFIG.REACT_APP_NEW_APP_PROD_URL
    : ENV_CONFIG.REACT_APP_NEW_APP_NON_PROD_URL

  useEffect(() => {
    if(!isMobile) {
      onSearchClose()
    }
  })

  return (
    <Header className={`app-header ${navMode}`} style={{backgroundColor: headerNavColor}}>
      <div className={`app-header-wrapper ${isNavTop ? 'layout-top-nav' : ''}`}>
        <Logo logoType={navMode}/>
        <div className="nav" style={{width: `calc(100% - ${getNavWidth()})`}}>
          <div className="nav-left">
            <ul className="ant-menu ant-menu-root ant-menu-horizontal">          
              {
                isNavTop && !isMobile ?
                null
                :
                <li className="ant-menu-item ant-menu-item-only-child" onClick={() => {onToggle()}}>
                  {navCollapsed || isMobile ? <MenuUnfoldOutlined className="nav-icon" /> : <MenuFoldOutlined className="nav-icon" />}
                </li>
              }
            </ul>
          </div>
          <div className="nav-right">
            {showNewAppCta && (
              <Menu className="d-flex align-item-center" mode="horizontal">
                <Menu.Item>
                  <Button
                    className="buttonText"
                    type="default"
                    href={newAppUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      background: "rgba(16, 190, 79, 0.08)",
                      borderColor: "#10be4f",
                      color: "#0b7f36",
                      fontWeight: 600,
                      textDecoration: "none",
                    }}
                  >
                    Try Our New App
                    <ExportOutlined
                      style={{
                        fontSize: "18px",
                        marginLeft: "10px",
                        verticalAlign: "-2px",
                      }}
                    />
                  </Button>
                </Menu.Item>
              </Menu>
            )}
            <NavProfile />
            <NavPanel />
          </div>
          <NavSearch active={searchActive} close={onSearchClose}/>
        </div>
      </div>
    </Header>
  )
}

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, navType, headerNavColor, mobileNav, currentTheme } =  theme;
  return { navCollapsed, navType, headerNavColor, mobileNav, currentTheme }
};

export default connect(mapStateToProps, {toggleCollapsedNav, onMobileNavToggle})(HeaderNav);